var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};

BOLD.BMS.GiftWithPurchase = function ($) {
    function init(data) {
        getCart(data);
        document.addEventListener("theme:cart:change", () => {
            getCart(data);
        });
    }

    function removeFreeGift(removalUpdateObj) {
        $.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            data: {
                updates: removalUpdateObj
            },
            success: function () {
                document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                    bubbles: true
                }));
            },
            error: function (err) {
                console.log('error....', err);
            }
        });
    }

    function addFreeGift(variantId, giftAmount, customerTag, allCustomer) {
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: {
                quantity: 1,
                id: variantId,
                properties: {
                    _bms_gwp: "Free Gift",
                    _bms_gwp_amount: giftAmount,
                    _bms_gwp_customer_tag: customerTag,
                    _bms_gwp_all_customer: allCustomer
                }
            },
            success: function () {
                document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                    bubbles: true
                }));
            }
        });
    }

    function enableDelete() {
        var freeItem = $('a.bms-gwp-free.bold-ro-remove');
        freeItem.on('click', function () {
            sessionStorage.setItem('remove_gwp', true);
            $.ajax({
                url: '/cart/update.js',
                type: 'post',
                dataType: 'json',
                data: {
                    attributes: {
                        'Removed Gift With Purchase': true
                    }
                },
                success: function () {
                    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                        bubbles: true
                    }));
                }
            });
        });
    }

    function getCart(data) {
        $.getJSON('/cart.js', function (cart) {
            var removeId = "Free Gift",
                removals = cart.items.filter(function (item) {
                    return item.properties && item.properties["_bms_gwp"] == removeId
                }),
                removalUpdateObj = removals.reduce(function (acc, item) {
                    acc[item.key] = 0;
                    return acc
                }, {});


            if (data.free_gift) {
                var freeGiftItem = data.free_gift.variants[0] || {},
                    itemShouldBeInTheCart = true;

                if (window.sessionStorage && (sessionStorage.getItem('remove_gwp') != null || sessionStorage.getItem('remove_gwp') != undefined)) {
                    itemShouldBeInTheCart = false;
                }

                if (removals.length === 0 && cart.total_price >= data.gift_amount && data.enable_gwp && itemShouldBeInTheCart) {
                    addFreeGift(freeGiftItem.id, data.gift_amount, data.customer_tag, data.free_gift_all);
                } else if (removals.length && cart.total_price < data.gift_amount) {
                    removeFreeGift(removalUpdateObj);
                } else if (removals.length && data.enable_gwp == false) {
                    removeFreeGift(removalUpdateObj);
                } else if (removals.length && itemShouldBeInTheCart && removals[0].id !== freeGiftItem.id) {
                    removeFreeGift(removalUpdateObj);
                    getCart(data);
                } else if (removals.length) {
                    enableDelete();
                }
            } else if (removals.length) {
                removeFreeGift(removalUpdateObj);
            }

        })
    }
    return {
        init: init
    }

}(BOLD.jQuery || jQuery)
